import Styles from '../LinkManager.module.scss'
import { Button } from 'blaze-ui/Button'
import { Input } from 'almanac-ui/TextInputField/Input'
import { useState } from 'react'
import { checkUrl } from 'utils/fileDownloadUtils'

interface AddLinkInputProps {
  onSubmit: (value: string) => void
  onCancel: () => void
}

export const AddLinkInput: React.FC<AddLinkInputProps> = ({ onSubmit, onCancel }) => {
  const [value, setValue] = useState('')
  const [errorMessage, setErrorMessage] = useState('')

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setValue(e.target.value)
    if (errorMessage) {
      setErrorMessage('')
    }
  }

  const handleSubmit = () => {
    if (!value.trim()) return

    if (!checkUrl(value)) {
      setErrorMessage('Please enter a valid URL (e.g., https://example.com)')
      return
    }

    onSubmit(value)
  }

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault()
      handleSubmit()
    }
  }

  return (
    <>
      <Input
        name="linkInput"
        value={value}
        onChange={handleInputChange}
        placeholder="https://example.com"
        isValid={!errorMessage}
        errorMessage={errorMessage}
        autoFocus
        onKeyDown={handleKeyDown}
        variant="grey"
        autoComplete="off"
      />
      <div className={Styles.addLinkButtonContainer}>
        <Button
          variant="tertiary"
          size="md"
          onPress={() => {
            onCancel()
            return false
          }}
          fullWidth
        >
          Cancel
        </Button>
        <Button variant="primary" size="md" onPress={handleSubmit} isDisabled={!value.trim()} fullWidth>
          Add Link
        </Button>
      </div>
    </>
  )
}
